import { FC, ReactNode } from 'react';
import CloseIcon from '@mui/icons-material/Close';
import { Box, IconButton, Typography } from '@mui/material';

interface SidepanelHeaderProps {
  title: string;
  onClose: () => void;
  /** Small muted label above the subtitle (e.g. "Company") */
  subtitleLabel?: string;
  /** Bold text beneath the label (e.g. company name) */
  subtitle?: string;
  /** Optional right-side slot on the subtitle row (e.g. "+ Add Game" button) */
  rightAction?: ReactNode;
}

const SidepanelHeader: FC<SidepanelHeaderProps> = ({
  title,
  onClose,
  subtitleLabel,
  subtitle,
  rightAction,
}) => (
  <Box sx={{ flexShrink: 0 }}>
    {/* Title row */}
    <Box
      sx={{
        height: 64,
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        mb: '1rem',
      }}
    >
      <Typography fontSize={22} fontWeight={700} sx={{ color: '#162936' }}>
        {title}
      </Typography>
      <IconButton onClick={onClose} size="small" disableRipple>
        <CloseIcon sx={{ color: '#162936' }} />
      </IconButton>
    </Box>

    {/* Subtitle row — only rendered when subtitle or rightAction is provided */}
    {(subtitle || rightAction) && (
      <Box
        sx={{
          pb: '0.75rem',
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'flex-end',
        }}
      >
        {subtitle && (
          <Box sx={{ display: 'flex', flexDirection: 'column', gap: '2px' }}>
            {subtitleLabel && (
              <Typography fontSize={12} sx={{ color: '#6C6C6C' }}>
                {subtitleLabel}
              </Typography>
            )}
            <Typography fontSize={18} fontWeight={700} sx={{ color: '#162936' }}>
              {subtitle}
            </Typography>
          </Box>
        )}
        {rightAction}
      </Box>
    )}
  </Box>
);

export default SidepanelHeader;
